import React from "react";
import { useSelector } from "react-redux";
import LoadingIcons from "~/Common-Objects/LoadingIcons/loadingIcon1";
import * as styles from "./index.module.scss";
import classNames from "classnames";

export default function SettingsLayout({
  loading,
  heading,
  subheading,
  backButton,
  sideNavList,
  breadcrumbs,
  children,
  rightContent,
  hideHeader,
  view,
  hideLeftNav
}) {
  const siteMaster = useSelector(state => state.siteMaster)
  let top = 24 + 64
  if (siteMaster.hasBanner) {
    top += 64
  }

  const sideNavClasses = classNames(siteMaster.hasBanner ? 'withBanner' : '', styles.sideNav)
  const mainClasses = classNames(siteMaster.hasBanner ? 'withBanner' : '', styles.main)
  return (
    <div className={styles.root}>

      {!hideLeftNav && <nav className={sideNavClasses}>
        <div className={styles.backButton}>{backButton}</div>

        <div className={styles.sideNavListWrapper}>{sideNavList}</div>
      </nav>}
      {hideLeftNav && backButton && <div className={styles.backButton} style={{ position: "absolute", left: 24, top: top }}>{backButton}</div>}

      <main className={mainClasses} >
        {loading ? (
          <LoadingIcons />
        ) : (
          <div className="row">
            <div className="col-xs-12">
              {breadcrumbs}
            </div>
            {children}
          </div>
        )}
      </main>
    </div>
  );
}
